namespace RedBullMOBILE360.Sms {
    export interface WhitelistMemberForm {
        WhitelistId: Serenity.LookupEditor;
        Msisdn: Serenity.StringEditor;
        AddDate: Serenity.DateEditor;
        AddBy: Serenity.IntegerEditor;
    }

    export class WhitelistMemberForm extends Serenity.PrefixedContext {
        static formKey = 'Sms.WhitelistMember';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WhitelistMemberForm.init)  {
                WhitelistMemberForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.IntegerEditor;

                Q.initFormType(WhitelistMemberForm, [
                    'WhitelistId', w0,
                    'Msisdn', w1,
                    'AddDate', w2,
                    'AddBy', w3
                ]);
            }
        }
    }
}
